// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1UU_J","buttons":"SendReceipts_buttons__nShvI","email":"SendReceipts_email__1Mybd","bookApptTitle":"SendReceipts_bookApptTitle__3Adtl"};